<template>
  <aside class="col-sm-2">
		<nav id="nav-side">
		  <div class="navbar-brand">
        <img src="https://static.bienparabien.com/apps/img/logo_gradiente.png" alt="Logo BpB" width="200px">
      </div>
      <ol class="nav flex-column navbar-menu" data-menu="0">
        <li class="nav-item active">
          <router-link :to="{name: 'mis-creditos'}" class="nav-link d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
              <img src="../assets/img/credit.png" alt="Créditos">
              <span>Mis Créditos</span>
            </div>
            <img src="../assets/img/right-arrow.png" alt="Créditos">
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'mi-perfil'}" class="nav-link d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
              <img src="https://static.bienparabien.com/img/icons/user.png" alt="perfil" width="20px">
              <span>Mi perfil</span>
            </div>
            <img src="../assets/img/right-arrow.png" alt="Créditos">
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'tips'}" class="nav-link d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
              <img src="../assets/img/money.png" alt="Créditos">
              <span>Tips</span>
            </div>
            <img src="../assets/img/right-arrow.png" alt="Créditos">
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'blogs'}" class="nav-link d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
              <img src="../assets/img/blog.png" alt="Créditos">
              <span>Blog</span>
              <span v-if="$store.state.noLeidas > 0" class="badge badge-success no-leidas" title="Entradas del blog no leidas">{{ $store.state.noLeidas }}</span>
            </div>
            <img src="../assets/img/right-arrow.png" alt="Créditos">
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'ayuda'}" class="nav-link d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
              <img src="../assets/img/help.png" alt="Créditos">
              <span>Ayuda</span>
            </div>
            <img src="../assets/img/right-arrow.png" alt="Créditos">
          </router-link>
        </li>
        <!--- OPEN BANKING DESHABILITADO ---------->
        <!--<li class="nav-item">
          <router-link :to="{name: 'open_banking'}" class="nav-link d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
              <img src="../assets/img/payment.png" alt="Open Banking">
              <span>Open Banking</span>
            </div>
            <img src="../assets/img/right-arrow.png" alt="Open Banking">
          </router-link>
        </li>-->
      </ol>
    </nav>
	</aside>
</template>

<script type="text/javascript">
  import api from '@/api/clientes'

  export default {
    data: function() {
      return {
        noLeidas: 0
      }
    }
    ,mounted: function() {
      this.cargar_no_leidas();
    },
    methods: {
      cargar_no_leidas: async function() {
        try {
          let noLeidas = (await api.obtener_blog_noleidas()).data;
          this.$store.commit('setNoLeidas', noLeidas);
        }catch(e) {
          this.$log.info('Err', e);
          this.$swal('Error','Error al descargar las facturas: '+e.message,'error');
        }
      }
    }
  }
</script>

<style lang="css">
  .no-leidas {
    display:block;
    animation: alert 4s .7s ease-in-out infinite;
    transform-origin: 50% 4px;
  }

  @keyframes alert {
    0% { transform: rotate(0); }
    1% { transform: rotate(30deg); }
    3% { transform: rotate(-28deg); }
    5% { transform: rotate(34deg); }
    7% { transform: rotate(-32deg); }
    9% { transform: rotate(30deg); }
    11% { transform: rotate(-28deg); }
    13% { transform: rotate(26deg); }
    15% { transform: rotate(-24deg); }
    17% { transform: rotate(22deg); }
    19% { transform: rotate(-20deg); }
    21% { transform: rotate(18deg); }
    23% { transform: rotate(-16deg); }
    25% { transform: rotate(14deg); }
    27% { transform: rotate(-12deg); }
    29% { transform: rotate(10deg); }
    31% { transform: rotate(-8deg); }
    33% { transform: rotate(6deg); }
    35% { transform: rotate(-4deg); }
    37% { transform: rotate(2deg); }
    39% { transform: rotate(-1deg); }
    41% { transform: rotate(1deg); }

    43% { transform: rotate(0); }
    100% { transform: rotate(0); }
  }
</style>